import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { T } = useLanguage();
  const links = [
    { to: "/", label: T.nav.home }, { to: "/sobre", label: T.nav.about }, { to: "/tratamentos", label: T.nav.treatments },
    { to: "/precos", label: T.nav.pricing }, { to: "/contato", label: T.nav.contact },
  ];
  return (
    <footer className="bg-[#9B6179] text-[#F7F0E8] pt-10 pb-5 px-6 lg:px-16 border-t border-[#E8C47A]/15" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto">
        <p className="uppercase tracking-[0.15em] font-normal text-[7vw] sm:text-3xl lg:text-4xl leading-[1.1] text-[#E8C47A]/95 mb-6">
          Studio Carolina Aguiar
        </p>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-t border-[#F7F0E8]/10 pt-4">
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-[11px] tracking-[0.15em] uppercase text-[#F7F0E8]/60">
            {links.map((l, i) => (
              <span key={l.to} className="flex items-center gap-6">
                <Link to={l.to} data-testid={`footer-link-${l.to.replace("/", "") || "home"}`} className="hover:text-[#E8C47A] transition-colors">{l.label}</Link>
                {i < links.length - 1 && <span className="text-[#F7F0E8]/20">/</span>}
              </span>
            ))}
          </nav>

          <div className="text-sm text-[#F7F0E8]/70 space-y-1">
            <p>{T.footer.hours_line1}</p>
            <p className="text-[#F7F0E8]/40 text-xs">{T.footer.hours_line2}</p>
            <p className="text-[#F7F0E8]/40 text-xs">{T.footer.address} · +33 7 51 33 25 07</p>
          </div>

          <div className="flex gap-4">
            <a href="https://instagram.com/studiocarolinaaguiar" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="text-[#F7F0E8]/60 hover:text-[#E8C47A] transition-colors"><Instagram className="w-4 h-4" /></a>
          </div>
        </div>

        <div className="mt-5 pt-3 border-t border-[#F7F0E8]/10 flex flex-col sm:flex-row justify-between gap-2 text-[10px] tracking-wide text-[#F7F0E8]/35">
          <p>© 2026 Studio Carolina Aguiar. {T.footer.rights}</p>
          <p className="font-script text-base text-[#E8C47A]/60 normal-case tracking-normal">{T.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
};
